import selectOption from '@/store/dict/selectOptionDict'
import Vue from 'vue'
import { operateMaxShowLength } from '@/store/dict/config'
import * as Sentry from '@sentry/vue'
import { setLocalStorage } from '@/utils/cache'

const { $createElement } = Vue.prototype.$EventBus
const isTemplate = {
  0: '否',
  1: '是',
}

const AIValidState = {
  '-1': '校验中',
  1: '通过',
  0: '不通过',
}

export const storageKeyAdd = 'tinymce_contract_content_add'
export const storageTitleKeyAdd = 'tinymce_contract_title_add'
export const storageAiUuidKeyAdd = 'tinymce_contract_ai_uuid_add'

export const storageKeyEdit = 'tinymce_contract_content_edit'
export const storageTitleKeyEdit = 'tinymce_contract_title_edit'

export const TinymcevueOptions = {
  branding: false,
  elementpath: false,
  draggable_modal: true,
  paste_auto_cleanup_on_paste: true,
  paste_remove_styles: true,
  paste_remove_styles_if_webkit: true,
  paste_strip_class_attributes: true,
  min_height: 550,
  max_height: 550,
  cleanup: false,
  language: 'zh_CN',
  menubar: false,
  external_plugins: {},
  plugins: [
    'table', 'paste', 'preview', 'searchreplace', 'autolink', 'fullscreen', 'image', 'link', 'media',
    'code', 'codesample', 'charmap', 'pagebreak', 'nonbreaking', 'anchor', 'advlist', 'lists', 'help',
    'emoticons', 'autosave', 'quickbars', 'wordcount', 'autoresize', 'importword', 'imagetools',
  ],
  toolbar: [
    'table tabledelete | tableprops tablerowprops tablecellprops | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol |formatselect fontsizeselect forecolor backcolor bold italic underline strikethrough alignleft aligncenter alignright outdent indent bullist numlist blockquote subscript superscript removeformat table image lineheight undo redo importword',
  ],
  setup(editor) {
    editor.on('paste', (e) => {
      const { items } = e.clipboardData || e.originalEvent.clipboardData
      if (items) {
        for (let i = 0; i < items.length; i++) {
          if (items[i].kind === 'file' && items[i].type.match(/^image\/(png|jpe?g|gif|webp|svg\+xml)$/)) {
            const blob = items[i].getAsFile()
            const reader = new FileReader()
            reader.onload = function (event) {
              const base64Data = event.target.result
              editor.insertContent(`<img src="${base64Data}" alt="Pasted Image">`)
              e.preventDefault() // 阻止默认粘贴行为
            }
            reader.readAsDataURL(blob)
          }
        }
      }
    })
    editor.on('change', () => {
      const content = editor.getContent()

      const urlParams = new URLSearchParams(window.location.search)
      const editFlag = urlParams.get('editFlag')
      const isEdit = editFlag === 'true'

      // 保存到本地存储
      try {
        setLocalStorage(isEdit ? storageKeyEdit : storageKeyAdd, content)
      } catch (error) {
        Sentry.captureException(error)
      }
    })
  },
  paste_preprocess(_, args) {
    // 解析粘贴的 HTML 内容
    const html = args.content
    const parser = new DOMParser()
    const doc = parser.parseFromString(html, 'text/html')
    const images = doc.querySelectorAll('img')

    // 处理图片
    images.forEach((img) => {
      if (img.src.startsWith('data:')) {
        // 如果已经是 base64 格式，直接插入
        args.content = args.content.replace(img.src, img.src)
      }
    })

    // 更新粘贴内容
    args.content = doc.body.innerHTML
  },
}

export const titleMap = new Map([
  ['add', '新增合同模板'],
  ['edit', '编辑合同模板'],
])

export const tableColumn = [
  {
    name: 'id',
    columnProps: {
      label: '合同模板ID',
      prop: 'id',
    },
  },
  {
    name: 'bizType',
    columnProps: {
      label: '合同业务类型',
      prop: 'bizType',
    },
    render: ({ row }) =>
      $createElement(
        'span',
        {},
        selectOption.contractBusinessTypeDict[row.bizType] || '--',
      ),
  },
  {
    name: 'name',
    columnProps: {
      label: '合同模板名称',
      prop: 'name',
    },
  },
  {
    name: 'state',
    columnProps: {
      label: '合同模板状态',
      prop: 'state',
    },
    render: ({ row }) =>
      $createElement(
        'span',
        {},
        selectOption.accountStateDict[row.state] || '--',
      ),
  },
  {
    name: 'valid',
    columnProps: {
      label: 'AI校验结果',
      prop: 'valid',
    },
    getText: ({ row }) => AIValidState[row.valid] || '--',
  },
  {
    name: 'reason',
    columnProps: {
      label: '校验不通过原因',
      prop: 'reason',
      width: 200,
    },
  },
  {
    name: 'isDefault',
    columnProps: {
      label: '是否默认模版',
      prop: 'isDefault',
    },
    getText: ({ row }) => isTemplate[row.isDefault],
  },
  {
    name: 'gmtCreate',
    columnProps: {
      label: '创建日期',
      prop: 'gmtCreate',
      width: '200px',
    },
  },
  {
    name: 'gmtModified',
    columnProps: {
      label: '最近更新日期',
      prop: 'gmtModified',
      width: '200px',
    },
  },
  {
    name: 'operate',
    columnProps: {
      label: '操作',
      fixed: 'right',
      width: 240,
    },
    maxShowLength: operateMaxShowLength,
    type: 'operate',
  },
]

export const GROUP_CONTRACT_TEMPLATE = 'tenant_new_contract_template'

export const GROUP_CONTRACT_TEMPLATE_PREVIEW =
  'tenant_new_contract_template_list_preview'


export const GROUP_CONTRACT_TEMPLATE_EDIT =
  'tenant_new_contract_template_list_edit'

export const GROUP_CONTRACT_TEMPLATE_ENABLE =
  'tenant_new_contract_template_list_enable_and_disable'

export const GROUP_CONTRACT_TEMPLATE_CREATE =
  'tenant_new_contract_template_list_create'

export const ADD_GROUP_CONTRACT_TEMPLATE_PATH =
  '/tenantNew/contractTemplate/add'

export const EDIT_GROUP_CONTRACT_TEMPLATE_PATH =
  '/tenantNew/contractTemplate/edit'


export const exmUrl =
  'https://server-resource-v4.cheweijia.com/public/assets/templates/jaguar/437BBE6192A1DD54023E3E7B44CA0C38.jpeg'
